import React from "react";
import { makeStyles } from "@mui/styles";
import { Box, Button } from "@mui/material";
import { rem } from "assets/js/common";
import { useDispatch, useSelector } from "react-redux";
import { loadAction } from "redux/reducers/top";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  ReactChannelIO,
  useChannelIOApi,
  useChannelIOEvent,
} from "react-channel-plugin";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { Cookies } from "react-cookie";

const useStyles = makeStyles((theme) => ({
  customer: {
    "& .customer-info": {
      position: "relative",
      "& .tit": {
        fontSize: rem(14),
      },
      "& .phone": {
        marginTop: rem(2),
        fontSize: rem(28),
        fontWeight: 700,
        letterSpacing: "-0.2px",
      },
      "& .info-txt": {
        marginTop: rem(6),
        "& .ico-clock": {
          margin: `0 ${rem(4)} ${rem(2)} 0`,
        },
      },
      "&::after": {
        position: "absolute",
        top: rem(22),
        right: rem(20),
        content: "''",
        display: "inline-block",
        width: rem(54),
        height: rem(52),
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundImage: `url(${
          process.env.PUBLIC_URL
        }/images/icon/customer.svg)`,
      },
    },
    "& .link-box": {
      backgroundColor: theme.palette.background.default,
      display: "flex",
      alignItems: "center",
      padding: `${rem(24)} ${rem(20)}`,
      borderRadius: rem(10),
      "& i": {
        display: "block",
        width: rem(34),
        height: rem(34),
        marginRight: rem(14),
      },
      "& .info-txt": {
        display: "inline-block",
        marginLeft: rem(6),
      },
      "& + .link-box": {
        marginTop: rem(10),
      },
    },
  },
}));

export default function CustomerIndex() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const cookies = new Cookies();

  // 상태 추가
  const [favoriteStoreDetail, setFavoriteStoreDetail] = useState(null);

  // 쿠키에서 favMk || favMt 값 가져오기
  const favInfo = cookies.get("favInfo") || {};
  const cd = favInfo.favMt || favInfo.favMk || "2701"; // 메가마트,메가마켓 단골매장 번호 무조건 둘중 한개밖에 값을 갖고있지않음, 값이없는유저에경우 2701 (2701: 메가마트 동래점)

  const { init } = useSelector((state) => state.top);
  useEffect(() => {
    if (init)
      dispatch(loadAction({ back: true, title: "고객센터", menu: false }));
  }, [init]);

  const loadDetail = async () => {
    await axios
      .get(`/api/sm/store/get/${cd}`)
      .then((res) => {
        console.log("res: ", res);
        setFavoriteStoreDetail(res.data.data.store);
      })
      .catch((error) => {
        console.error("error: ", error);
      });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    loadDetail();
  }, [cd]);

  window.appBackKeyHandle = () => {
    history.goBack();
  };

  const AppPage = () => {
    const { showMessenger } = useChannelIOApi();

    useChannelIOEvent("onShowMessenger", () => {
      console.log("Messenger opened!");
    });

    const goChatBot = (e) => {
      e.preventDefault();
      showMessenger();
    };

    return (
      <a className="link-box" href="#" onClick={goChatBot}>
        <i>
          <img src={`${process.env.PUBLIC_URL}/images/icon/chatbot.svg`} />
        </i>
        <div className="link-cont">
          <b>온라인몰 챗봇 문의</b>
          <span className="info-txt">매일 10:00 ~ 18:00</span>
        </div>
      </a>
    );
  };

  return (
    <main id="main" className={"container nopad " + classes.customer}>
      <div className="box-type-2">
        <div className="customer-info">
          <p className="tit">전화문의 {`(${favoriteStoreDetail?.nm})`}</p>
          <a className="phone" href={`tel:${favoriteStoreDetail?.tel}`}>
            {favoriteStoreDetail?.tel}
          </a>
          <p className="info-txt">
            <i className="ico-clock" />
            영업일 {favoriteStoreDetail?.formatStrtTm} ~{" "}
            {favoriteStoreDetail?.formatEndTm}
          </p>
          <Box mt={2}>
            <Link to={`/favorite-store/detail/${cd}`}>
              <Button
                className="btn-rounded"
                color="primary"
                variant="contained"
                size="small"
                endIcon={<i className="ico-go-white" />}
              >
                매장상세 정보
              </Button>
            </Link>
          </Box>
        </div>
        <Box mt={8}>
          <ReactChannelIO
            pluginKey={"1832b4f0-13f5-46c0-8aa6-dddd06c3f76f"}
            hideChannelButtonOnBoot={true}
            mobileMessengerMode={"iframe"}
            language="ko"
            autoBoot
            autoBootTimeout={500}
          >
            <AppPage />
          </ReactChannelIO>
          <Link className="link-box" to={"/faq/list"}>
            <i>
              <img src={`${process.env.PUBLIC_URL}/images/icon/faq.svg`} />
            </i>
            <div className="link-cont">
              <b>자주하는 질문 [FAQ]</b>
            </div>
          </Link>
        </Box>
      </div>
    </main>
  );
}
